import { Injectable, Type } from '@angular/core';
import {
  ApiResponse,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import { IOdb } from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';
import { AccessPoint } from '../models/access-point.model';

@Injectable({
  providedIn: 'root',
})
export class AccessPointsService extends BaseApiService<AccessPoint> {
  override model: Type<AccessPoint> = AccessPoint;

  override get endpoint(): string {
    return '/access-points';
  }

  udpateTechnical(id: string, data: Partial<AccessPoint>) {
    return this.http.put<AccessPoint>(`${this.endpoint}/${id}/technical`, data);
  }

  copy(id: string) {
    return this.http.get<AccessPoint>(`${this.endpoint}/${id}/copy`);
  }

  getOdbsByApId(id: string) {
    return this.http
      .get<{ data: IOdb[] }>(`${this.endpoint}/${id}/odbs`)
      .pipe(map((res) => res.data));
  }

  getServicePartner(locationId: string) {
    return this.http
      .get<
        ApiResponse<{ servicePartner: string }>
      >(`/locations/${locationId}/service-partner`)
      .pipe(map((res) => res.data));
  }

  refreshFromSsd(id: string) {
    return this.http.post(`${this.endpoint}/${id}/refresh-from-ssd`, {});
  }
}
